import React, { useEffect, useState } from 'react';
import { AmityUiKitSocial, AmityPostDetailPage } from '@frn/amityco-ui-kit-open-source';
// eslint-disable-next-line import/no-webpack-loader-syntax
import socialPlusStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!@frn/amityco-ui-kit-open-source/dist/index.css';
import overrideStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./globalOverrides.css';
import postDetailOverrides from '!!css-loader?{"sourceMap":false,"exportType":"string"}!./postDetailOverrides.css';

import ErrorBoundary from '../ErrorBoundary';
import useAutoJoinSocialPlusCommunity from './useAutoJoinSocialPlusCommunity';

const SocialPlusForum = ({ style, useForum = true, postId, autoJoinCommunityIds = [] }) => {
  const [sharedPost, setSharedPost] = useState('');

  const urlToPath = () => {
    let path = null;
    const urlParts = location.hash.split('/');
    if (urlParts[1] === 'post') {
      if (urlParts[2]) {
        path = {
          post: urlParts[1],
          postId: urlParts[2]
        };
      }
    }
    if (urlParts[3] && urlParts[3] === 'comment') {
      if (path && urlParts[4]) {
        path['comment'] = urlParts[3];
        path['commentId'] = urlParts[4];
      }
    }
    return path;
  };

  useEffect(() => {
    let path = urlToPath();
    if (path) setSharedPost(path);
  }, []);

  if (postId) setSharedPost({ postId });

  if (autoJoinCommunityIds.length > 0) useAutoJoinSocialPlusCommunity(autoJoinCommunityIds);

  return (
    <ErrorBoundary msg="Error loading the community forum, please refresh your browser.">
      <div
        className={useForum && 'socialplus-uikit-wrapper'}
        style={
          style || {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100vw',
            height: '100dvh'
          }
        }
      >
        <style type="text/css" scoped>
          {socialPlusStyles}
        </style>
        <style>{useForum && overrideStyles}</style>
        <style>{sharedPost && postDetailOverrides}</style>
        {sharedPost && <AmityPostDetailPage id={sharedPost.postId} commentId={sharedPost.commentId} />}
        {useForum && !sharedPost && <AmityUiKitSocial />}
      </div>
    </ErrorBoundary>
  );
};

export default SocialPlusForum;
